import {Editor} from "tinymce";
import * as ko from "knockout";
import {PageData} from "./PageData";
import {ObjectTypeId} from "../../../../constants";
import {ErrorTracker} from "../../../../error.tracker";
import {global} from "../../../../appContext";
import {viewModel as MutableTemplate} from "./details";
import {KOSubscriptionTracker} from "../../../../util/KOSubscriptionTracker";
import pageHtml from './page.html?raw';

export let template = pageHtml;

interface IParams {
    template: MutableTemplate
    page: PageData
}

export class viewModel {
    private readonly ObjectTypeId = ObjectTypeId;
    private readonly editor: KnockoutObservable<Editor | null> = ko.observable(null);
    private readonly et: ErrorTracker = global.errorAreas.get('form.template.mutable');
    private readonly isReady: KnockoutObservable<boolean> = ko.observable(false);
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly page: PageData;
    private readonly template: MutableTemplate;

    constructor(params: IParams) {
        this.template = params.template;
        this.page = params.page;
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }
}
